/**
 * Safely call a function and handle errors.
 * @param fn Function to call safely
 * @param context Context for error logging
 * @param level Logging level for errors
 * @returns The result of the function call or undefined if an error occurred
 */
export function safeCall<T>(fn: () => T, context?: string, level: 'debug' | 'warn' | 'error' = 'debug'): T | undefined {
  try {
    return fn();
  } catch (e) {
    if (level === 'debug') console.debug(context || 'safeCall', e);
    else if (level === 'warn') console.warn(context || 'safeCall', e);
    else console.error(context || 'safeCall', e);
    return undefined;
  }
}

/**
 * Safely call an asynchronous function and handle errors.
 * @param fn Function to call safely
 * @param context Context for error logging
 * @param level Logging level for errors
 * @returns The result of the function call or undefined if an error occurred
 */
export async function safeCallAsync<T>(
  fn: () => Promise<T>,
  context?: string,
  level: 'debug' | 'warn' | 'error' = 'debug'
) {
  try {
    return await fn();
  } catch (e) {
    if (level === 'debug') console.debug(context || 'safeCallAsync', e);
    else if (level === 'warn') console.warn(context || 'safeCallAsync', e);
    else console.error(context || 'safeCallAsync', e);
    return undefined;
  }
}
